import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { CapacitacionesTable } from "../../../components/Admin/Capacitaciones/CapacitacionesTable";
import { useSite, useLanguage } from "../../../contexts";
import { useCompany } from "../../../contexts/CompanyContext";
import "./Capacitaciones.scss";

const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: 6 }, (_, i) => CURRENT_YEAR - 2 + i).reverse();

export function Capacitaciones() {
  const [reload,     setReload]     = useState(false);
  const [triggerNew, setTriggerNew] = useState(0);
  const [year,       setYear]       = useState(CURRENT_YEAR);

  const onReload = () => setReload((prev) => !prev);
  const { site }         = useSite();
  const { company }      = useCompany();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const hasSiteAndCompany =
    company && company !== "0" && company !== 0 &&
    site    && site    !== "0" && site    !== 0;

  return (
    <div className="capacitaciones-page">
      <div className="capacitaciones-page-header-row">
        <div className="capacitaciones-page-pill">
          <span className="capacitaciones-page-pill-title">{t("training_management")}</span>
          <div className="capacitaciones-page-year-wrapper">
            <span className="capacitaciones-page-year-label">{year}</span>
            <select
              className="capacitaciones-page-year-select"
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
            >
              {YEAR_OPTIONS.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
        </div>
        <Button icon className="capacitaciones-page-new-btn" onClick={() => setTriggerNew((n) => n + 1)}>
          <Icon name="plus" />
        </Button>
      </div>

      {!hasSiteAndCompany ? (
        <div className="no-site-warning">
          <Icon name="building outline" />
          <p>{t("select_company_site_from_header")}</p>
        </div>
      ) : (
        <CapacitacionesTable
          reload={reload}
          onReload={onReload}
          triggerNew={triggerNew}
          extYear={year}
        />
      )}
    </div>
  );
}
